export const USER_TYPE = {
  FACILITY_LEVEL: 'Facility Level User',
  FIELD_LEVEL: 'Field Level User',
  SUPER_ADMIN: 'Super Admin User',
  NATIONAL_LEVEL: 'National Level User',
  STATE_LEVEL: 'State Level User',
  DISTRICT_LEVEL: 'District Level User',
  ZONE_DIVISION_LEVEL: 'Zone / Circle / Region / Division Level User',
  ULB_LEVEL: 'ULB Level User',
  SUB_DISTRICT_LEVEL: 'Sub-District Level User',
  BLOCK_LEVEL: 'Block Level User',
  HEALTH_BLOCK_SUB_DIVISION_LEVEL: 'Health Block/ Sub Division Level User',
};

export const RURAL_URBAN = {
  RURAL: 'Rural',
  URBAN: 'Urban',
};

export const RURAL_URBAN_OPTION_IDS = {
  RURAL: '4485c41d-2142-43a2-b6d2-735b58caef09',
  URBAN: 'faf5bda0-4c2b-45ac-afd2-33e97d985d3e',
};

export const CREATOR_GROUPS = {
  SUPER_ADMIN_OR_NATIONAL: [USER_TYPE.SUPER_ADMIN, USER_TYPE.NATIONAL_LEVEL],
  SUPER_ADMIN_NATIONAL_OR_STATE: [
    USER_TYPE.SUPER_ADMIN,
    USER_TYPE.NATIONAL_LEVEL,
    USER_TYPE.STATE_LEVEL,
    USER_TYPE.ZONE_DIVISION_LEVEL,
  ],
};

export const FACILITY_AND_FIELD_USER_TYPES = [
  USER_TYPE.FACILITY_LEVEL,
  USER_TYPE.FIELD_LEVEL,
];

export const FACILITY_NAV_ITEMS = [
  'User Details',
  'Role & Hierarchy Details',
  'Facility Details',
];

export const DEFAULT_NAV_ITEMS = [
  'User Details',
  'Role & Hierarchy Details',
];

export const DESIGNATIONS_WITH_OPTIONAL_HPR = [
  'Hospital Adminstrator - DH and SDH',
  'Hospital Administrator - Other Central government hospitals',
  'Medical Director',
  'Medical Supritendent',
];

export const MPW_MPHW_DESIGNATION = 'MPW/MPHW';

export const OFFLINE_ENABLED_DESIGNATIONS = [
  'Community Health Officer - CHO',
  'ANM',
  'ASHA',
];
